import { render } from "./TaskIcon.vue?vue&type=template&id=a78a7a60&scoped=true"
import script from "./TaskIcon.vue?vue&type=script&lang=js"
export * from "./TaskIcon.vue?vue&type=script&lang=js"

import "./TaskIcon.vue?vue&type=style&index=0&id=a78a7a60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78a7a60"]])

export default __exports__